export const PHONE_NUMBERS = {
  india: {
    whatsapp: "919610006398",
    call: "+919610006398",
  },
  uae: {
    whatsapp: "+971565071346",
    call: "+971800500777",
  },
};

export function getWhatsAppUrl(phoneNumber, message = "") {
  const digits = String(phoneNumber || "").replace(/\D/g, "");
  const base = `https://wa.me/${digits}`;
  if (!message) return base;
  return `${base}?text=${encodeURIComponent(message)}`;
}

export function getCallUrl(phoneNumber) {
  const digits = String(phoneNumber || "").replace(/\D/g, "");
  return `tel:+${digits}`;
}
